import Footer from './Footer';
import { withErrorBoundary } from '../../SystemComponent/ErrorBoundary';

export default withErrorBoundary('Footer')(Footer);
